import React, { useEffect } from 'react';
import SearchableCriterion from './SearchableCriterion';

const CriteriaList = ({
  selectedCriteria,
  selectCriterion,
  deselectCriterion,
  loading,
  error,
  canUseCustomFeedbackCriteria,
  toggleModalState,
  currentUserId,
  query,
  criteria,
  selectedTagId,
}) => {
  const setContainerHeight = () => {
    const selector = query
      ? '.AddCriteriaModal--querying'
      : '.AddCriteriaModal-criteriaContainer';
    const container = document.querySelector(selector);

    if (container) {
      const maxHeight =
        window.innerHeight - container.getBoundingClientRect().top - 140;

      container.style.maxHeight = maxHeight + 'px';
    }
  };

  useEffect(() => {
    window.addEventListener('resize', setContainerHeight);
    setContainerHeight();

    return () => {
      window.removeEventListener('resize', setContainerHeight);
    };
  });

  const getCriteria = () => {
    const queryRegExp = new RegExp(query, 'i');

    return criteria.filter(
      criterion =>
        (queryRegExp.test(criterion.name) ||
          queryRegExp.test(criterion.description)) &&
        (selectedTagId === null || criterion.tags.includes(selectedTagId)),
    );
  };

  const renderResults = () => {
    const results = getCriteria();

    if (loading) {
      return <div className="fz-bigger">{t('common.loading')}</div>;
    }

    if (error) {
      return (
        <div className="AddCriteriaModal--error ErrorContainer ta-c lh-24 mb-0">
          {error}
        </div>
      );
    }

    if (results.length === 0) {
      return (
        <div className="AddCriteriaModal-criterion AddCriteriaModal-criterion--unclickable">
          {t('feedback_criteria.no_search_results')}
        </div>
      );
    }

    return results.map(criterion => (
      <SearchableCriterion
        key={criterion.id}
        criterion={criterion}
        selectedCriteria={selectedCriteria}
        selectCriterion={selectCriterion}
        deselectCriterion={deselectCriterion}
        noDescription={t('feedback_criteria.criterion.no_description')}
        canUseCustomFeedbackCriteria={canUseCustomFeedbackCriteria}
        toggleModalState={toggleModalState}
        editTooltip={t('feedback_criteria.custom_criterion.edit')}
        currentUserId={currentUserId}
      />
    ));
  };

  return (
    <div
      className={`${
        error || loading ? 'd-f ai-c jc-c h-150' : ''
      } AddCriteriaModal-criteriaContainer mb-32`}
    >
      <div className="AddCriteriaModal-criteriaList">{renderResults()}</div>
    </div>
  );
};

export default CriteriaList;
